<!--
  «Workflows» — la lista. Quien abre esta pantalla decide qué workflow revisar o cambiar: qué perfiles
  aprueban cada tipo de solicitud, en qué orden y a quién se le devuelve.
-->
<div class="kb-page kb-gateway">

  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title">Workflows</h1>
      <p class="kb-page-meta">Quién aprueba cada tipo de solicitud, en qué orden y a quién se le devuelve.</p>
    </div>
    <div class="flex items-center gap-2" *ngIf="!cargando && puedeConfigurar && tiposSinWorkflow.length">
      <div class="kb-select-envoltorio">
        <label class="sr-only" for="wfTipoNuevo">Tipo de solicitud del workflow nuevo</label>
        <select id="wfTipoNuevo" class="kb-select" [(ngModel)]="tipoNuevo">
          <option value="">Tipo de solicitud…</option>
          <option *ngFor="let t of tiposSinWorkflow" [value]="t.codigo">{{ t.nombre }}</option>
        </select>
        <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
      </div>
      <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" (click)="crear()" [disabled]="!tipoNuevo || creando">
        <i class="fas fa-plus" aria-hidden="true"></i>Nuevo workflow
      </button>
    </div>
  </div>

  <div class="space-y-6" *ngIf="cargando" aria-hidden="true">
    <div class="kb-skeleton h-40 w-full"></div>
  </div>
  <p class="sr-only" *ngIf="cargando">Cargando los workflows.</p>

  <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargando && error">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">No se pudieron traer los workflows</p>
      <p>{{ error }}</p>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="cargar()">
        <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar
      </button>
    </div>
  </div>

  <div class="kb-card" *ngIf="!cargando && !error">
    <div class="kb-card-header">
<div>
      <p class="kb-seccion-rotulo">Workflows · {{ filas.length }}</p>
      <p class="kb-card-desc">{{ filas.length ? 'Un renglón por tipo de solicitud, con la versión que rige hoy. Toca un renglón para ver sus perfiles.' : 'Aquí aparece cada tipo de solicitud con el workflow que lo aprueba.' }}</p>
      </div>
    </div>

    <div class="kb-card-body-plano" *ngIf="!filas.length">
      <p class="text-sm text-muted-foreground px-6 pb-6">
        Todavía no hay ningún workflow. {{ puedeConfigurar ? 'Elige un tipo de solicitud arriba y crea el primero.' : 'Pídele a quien configura que cree el primero.' }}
      </p>
    </div>

    <div class="kb-table-envoltorio" *ngIf="filas.length">
      <table class="kb-table">
        <thead class="kb-thead">
          <tr>
            <th class="kb-th">Workflow</th>
            <th class="kb-th">Versión que rige</th>
            <th class="kb-th">Estado</th>
            <th class="kb-th kb-th-num">Perfiles</th>
            <th class="kb-th kb-th-num">Solicitudes en curso</th>
            <th class="kb-th">Actualizado</th>
            <th class="kb-th"><span class="sr-only">Abrir</span></th>
          </tr>
        </thead>
        <tbody>
          <tr class="kb-tr kb-tr-clic last:border-b-0" *ngFor="let f of filas" tabindex="0"
              (click)="abrir(f)" (keydown.enter)="abrir(f)">
            <td class="kb-td">
              <span class="kb-td-titulo">{{ f.nombre }}</span>
              <p class="kb-td-sub" *ngIf="f.tipo_nombre !== f.nombre">Tipo de solicitud: {{ f.tipo_nombre }}</p>
            </td>
            <td class="kb-td">
              <code class="rounded bg-muted px-1.5 py-0.5 font-mono text-xs" *ngIf="f.publicado">v{{ f.publicado.version }}</code>
              <span class="text-muted-foreground" *ngIf="!f.publicado">—</span>
              <span class="kb-badge kb-badge-alerta ml-2" *ngIf="f.borrador">v{{ f.borrador.version }} en borrador</span>
            </td>
            <td class="kb-td">
              <span class="kb-badge kb-badge-exito" *ngIf="f.publicado">Publicado</span>
              <span class="kb-badge kb-badge-alerta" *ngIf="!f.publicado">Borrador</span>
            </td>
            <td class="kb-td kb-td-num">{{ (f.publicado || f.borrador)?.perfiles }}</td>
            <td class="kb-td kb-td-num">{{ f.solicitudes_en_curso }}</td>
            <td class="kb-td">{{ fecha(f.actualizado_at) }}</td>
            <td class="kb-td text-right text-muted-foreground"><i class="fas fa-chevron-right" aria-hidden="true"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <p class="text-xs text-muted-foreground" *ngIf="!cargando && !error && filas.length && !tiposSinWorkflow.length">
    Cada tipo de solicitud ya tiene su workflow. Para cambiar uno, ábrelo y edítalo: se crea la versión siguiente.
  </p>
</div>
